import { ReactComponent as IconSvg } from './icon_minus_in_circle.svg';
import Icon, { IconProps } from './icon';

const IconMinusInCircle = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconMinusInCircle;
